// import React, { useEffect, useState } from 'react';
// import { useSearchParams } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { Box, Typography } from '@mui/material';
// import {
//   getCompanyData,
//   getRideAnalytic,
//   getRideDetails,
//   getTopCompanies,
//   getTotalRegistration,
// } from 'redux/actions/UserDashboard';
// import { getOurCar } from 'redux/actions/UserTopSection';
// import { getServiceCity } from 'redux/actions/UserServiceCity';
// import { updateCompany } from 'redux/actions/companyAction';
// import { onLoaderTrigger } from 'redux/actions/commonAction';
// import ChartComponent from 'components/chartComponent/ChartComponent';
// import CommonTable from 'components/commonTable/CommonTable';
// import CommonSubHeader from 'components/commonSubHeader/CommonSubHeader';
// import CommonDialog from 'components/commonDialog/CommonDialog';
// import CommonPreviewDialog from 'components/commonPreviewDialog/CommonPreviewDialog';
// import Loader from 'components/loader/Loader';
// import TopCompanies from './TopCompanies';
// import { getDateFormat, handlePermissions, hasPermission } from 'utils/utils';
// import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
// import useModal from 'hooks/useModal';
// import { dashboardCardData, updateCompanyDoc } from './dashboardData';
// import DashboardCard from './DashboardCard';
// import './Dashboard.scss';

// const Dashboard = () => {
//   const dispatch = useDispatch();
//   const [searchParams, setSearchParams] = useSearchParams();
//   const startDate = searchParams?.get('startDate');
//   const endDate = searchParams?.get('endDate');
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const { open, toggle } = useModal();
//   const { open: previewModel, toggle: setPrevieModel } = useModal();
//   const [isUpdateFromDashboard, setIsUpdateFromDashboard] = useState(false);

//   const [companyDetails, setCompanyDetails] = useState('');
//   const locationData = useSelector(
//     (state) => state?.userServiceCity?.userServiceCity?.data
//   );
//   const userProfileData = useSelector(
//     (state) => state?.auth?.userProfile?.data
//   );
//   const dashBorardUpperData = useSelector(
//     (state) => state?.userRideDetails?.userRideDetails?.data?.body?.[0]
//   );
//   const topCompanies = useSelector(
//     (state) => state?.userTopCompanies?.topCompanies?.data
//   );
//   const companyLoader = useSelector(
//     (state) => state?.userTopCompanies?.loading
//   );
//   const companyData = useSelector(
//     (state) => state?.userCompanyData?.companyData?.data
//   );
//   const companyDataLoader = useSelector(
//     (state) => state?.userCompanyData?.loading
//   );
//   const companyUpdateSuccess = useSelector(
//     (state) => state?.updateCompany?.onBoardedCompay?.success
//   );
//   const userSideNavData = useSelector(
//     (state) => state?.getRolesAndPermissions?.rolesAndPermissions
//   );

//   const thirtyDaysAgo = new Date();
//   thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
//   const [dateFrom, setDateFrom] = useState(
//     startDate && startDate !== 'null'
//       ? startDate
//       : startDate === 'null'
//       ? ''
//       : getDateFormat(thirtyDaysAgo, 'reservationDateFormat')
//   );
//   const [dateTo, setDateTo] = useState(
//     endDate && endDate !== 'null'
//       ? endDate
//       : endDate === 'null'
//       ? ''
//       : getDateFormat(new Date(), 'reservationDateFormat')
//   );

//   const [locValue, setLocValue] = useState(locationData);

//   let filterData = {
//     dateFrom: dateFrom,
//     dateTo: dateTo,
//     location: userProfileData?.Company?.ServiceCity?.id || '',
//   };

//   let companyPayload = {
//     page: page,
//     pageSize: rowsPerPage,
//     dateFrom: dateFrom,
//     dateTo: dateTo,
//     location: userProfileData?.Company?.ServiceCity?.id || '',
//   };

//   useEffect(() => {
//     dispatch(getServiceCity());
//   }, []);

//   useEffect(() => {
//     if (userProfileData?.Company?.ServiceCity?.id) {
//       setLocValue({
//         id: userProfileData?.Company?.ServiceCity?.id,
//         name: userProfileData?.Company?.ServiceCity?.name,
//       });
//     }
//   }, [userProfileData?.Company?.ServiceCity?.id]);

//   useEffect(() => {
//     if (userProfileData?.subRole) {
//       dispatch(getRideDetails(filterData));
//       dispatch(getTotalRegistration(filterData));
//       dispatch(getRideAnalytic(filterData));
//       dispatch(getOurCar(filterData));
//       dispatch(getTopCompanies(filterData));
//       dispatch(getCompanyData(companyPayload));
//       dispatch(onLoaderTrigger(false));
//     }
//   }, [userProfileData?.subRole]);

//   const tableData = useSelector((state) => state);

//   const onSelectDateRange = (newValue) => {
//     if (newValue === null || newValue === 0) {
//       setSearchParams({ startDate: 'null', endDate: 'null' });
//       setDateFrom('');
//       setDateTo('');
//       filterData = { ...filterData, dateFrom: '', dateTo: '' };
//     } else {
//       setSearchParams({
//         startDate: getDateFormat(newValue[0], 'reservationDateFormat'),
//         endDate: getDateFormat(newValue[1], 'reservationDateFormat'),
//       });
//       setDateFrom(getDateFormat(newValue[0], 'reservationDateFormat'));
//       setDateTo(getDateFormat(newValue[1], 'reservationDateFormat'));
//       filterData = {
//         ...filterData,
//         dateFrom: getDateFormat(newValue[0], 'reservationDateFormat'),
//         dateTo: getDateFormat(newValue[1], 'reservationDateFormat'),
//       };
//     }
//     dispatch(getRideDetails(filterData));
//     dispatch(getTotalRegistration(filterData));
//     dispatch(getRideAnalytic(filterData));
//     dispatch(getTopCompanies(filterData));
//   };

//   const onInputChange = (e, data) => {
//     setLocValue(data);
//     filterData = { ...filterData, location: data?.id };
//     dispatch(getRideDetails(filterData));
//     dispatch(getTotalRegistration(filterData));
//     dispatch(getRideAnalytic(filterData));
//     dispatch(getTopCompanies(filterData));
//     dispatch(getCompanyData({ ...companyPayload, location: data?.id }));
//   };

//   const onClickMoreIcon = (value, type) => {
//     if (type === 'Renew') {
//       toggle();
//       setCompanyDetails(value);
//     }
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//     dispatch(getCompanyData({ ...companyPayload, page: newPage }));
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value));
//     setPage(0);
//     dispatch(
//       getCompanyData({
//         ...companyPayload,
//         page: 0,
//         pageSize: parseInt(event.target.value),
//       })
//     );
//   };

//   const onDialog = (data, image) => {
//     setIsUpdateFromDashboard(true);
//     let formData = new FormData();
//     formData.append('agreement', image);
//     formData.append('id', companyDetails?.companyId);
//     formData.append(
//       'contract[date]',
//       getDateFormat(data?.chooseDate['$d'], 'onboardingDateFormat')
//     );
//     formData.append(
//       'contract[startDate]',
//       getDateFormat(data?.tenure[0], 'tenureDateFormat')
//     );
//     formData.append(
//       'contract[endDate]',
//       getDateFormat(data?.tenure[1], 'tenureDateFormat')
//     );
//     dispatch(
//       updateCompany(formData, {
//         pageType: 'dashboardCompanyPage',
//         setPrevieModel: setPrevieModel,
//       })
//     );
//     toggle();
//   };

//   //roles and permissions
//   const roleAndPermissions = useSelector(
//     (state) => state?.getRolesAndPermissions?.rolesAndPermissions
//   );
//   const dashBoardRoleEnum = roleAndPermissionEnum.dashboard;
//   const accessForall = handlePermissions(
//     roleAndPermissions,
//     dashBoardRoleEnum.moduleKey,
//     {
//       defaultAllAccess: dashBoardRoleEnum.all,
//       customAccess: dashBoardRoleEnum.add,
//     }
//   );
//   const accessForOnlyView = handlePermissions(
//     roleAndPermissions,
//     dashBoardRoleEnum.moduleKey,
//     { customAccess: dashBoardRoleEnum.view }
//   );

//   const accessForRenewContract = handlePermissions(
//     roleAndPermissions,
//     dashBoardRoleEnum.moduleKey,
//     { customAccess: dashBoardRoleEnum.renewContract }
//   );

//   const hasRenew = accessForall || accessForRenewContract;

//   return (
//     <Box>
//       <Box className="dashboardSubHeader mb30">
//         <CommonSubHeader
//           selectCity={true}
//           onSelectDateRange={onSelectDateRange}
//           onInputChange={onInputChange}
//           locValue={locValue}
//           userProfileData={userProfileData}
//           Location={locationData}
//           dashboardSubHeader={true}
//           dateFrom={dateFrom}
//           dateTo={dateTo}
//         />
//       </Box>

//       <DashboardCard
//         cardData={dashboardCardData(dashBorardUpperData)}
//         dateFrom={dateFrom}
//         dateTo={dateTo}
//         locValue={locValue}
//       />

//       <Box className="mb25">
//         <ChartComponent tableData={tableData} />
//       </Box>
//       <Box className="mb25">
//         <TopCompanies data={topCompanies} loader={companyLoader} />
//       </Box>
//       <Box className="borderShadowGrey mb25 p25">
//         <Typography variant="head5" className="fw600">
//           Contract Renewal
//         </Typography>
//         {companyDataLoader ? (
//           <Loader height={'50vh'} />
//         ) : (
//           <CommonTable
//             data={companyData}
//             colorBlue="blue"
//             tabName={'companyData'}
//             onClickMoreIcon={onClickMoreIcon}
//             handleChangePage={handleChangePage}
//             handleChangeRowsPerPage={handleChangeRowsPerPage}
//             page={page}
//             rowsPerPage={rowsPerPage}
//             viewMoreIcon={!hasRenew}
//           />
//         )}
//       </Box>

//       <CommonDialog
//         className="mb20"
//         open={open}
//         handleClose={toggle}
//         button={'dialogButton'}
//         companyDetails={companyDetails}
//         onSubmittBtn={onDialog}
//         selectType={'updateDoc'}
//         type={'dashboardCompany'}
//         formData={updateCompanyDoc}
//         btnClass={'btnMedium'}
//       />

//       <CommonPreviewDialog
//         open={previewModel}
//         companyDetails={companyDetails}
//         handleClose={setPrevieModel}
//         companyPayload={companyPayload}
//       />
//     </Box>
//   );
// };

// export default Dashboard;

import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography, Tab, Tabs } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import {
  getCompanyData,
  getRideAnalytic,
  getRideDetails,
  getTopCompanies,
  getTotalRegistration,
} from 'redux/actions/UserDashboard';
import { getOurCar } from 'redux/actions/UserTopSection';
import { getServiceCity } from 'redux/actions/UserServiceCity';
import { updateCompany } from 'redux/actions/companyAction';
import { onLoaderTrigger } from 'redux/actions/commonAction';
import ChartComponent from 'components/chartComponent/ChartComponent';
import CommonTable from 'components/commonTable/CommonTable';
import CommonSubHeader from 'components/commonSubHeader/CommonSubHeader';
import CommonDialog from 'components/commonDialog/CommonDialog';
import CommonPreviewDialog from 'components/commonPreviewDialog/CommonPreviewDialog';
import Loader from 'components/loader/Loader';
import TopCompanies from './TopCompanies';
import { getDateFormat, handlePermissions } from 'utils/utils';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import useModal from 'hooks/useModal';
import { dashboardCardData, updateCompanyDoc } from './dashboardData';
import DashboardCard from './DashboardCard';
import { getVendorComplianceExpiryTracker } from 'services/VendorComplianceExpiryTrackerService';
import './Dashboard.scss';
// import { NewPagination } from 'components/ui/newPagination';

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const startDate = searchParams?.get('startDate');
  const endDate = searchParams?.get('endDate');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { open, toggle } = useModal();
  const { open: previewModel, toggle: setPrevieModel } = useModal();
  const [isUpdateFromDashboard, setIsUpdateFromDashboard] = useState(false);

  // Tab state
  const [tabValue, setTabValue] = useState('1');

  // Compliance expiry tab states
  const [complianceTrackerData, setComplianceTrackerData] = useState({});
  const [isLoadingComplianceTracker, setIsLoadingComplianceTracker] = useState(false);
  const [compliancePage, setCompliancePage] = useState(1);
  const [complianceRowsPerPage, setComplianceRowsPerPage] = useState(10);

  const [companyDetails, setCompanyDetails] = useState('');
  const locationData = useSelector((state) => state?.userServiceCity?.userServiceCity?.data);
  const userProfileData = useSelector((state) => state?.auth?.userProfile?.data);
  const dashBorardUpperData = useSelector(
    (state) => state?.userRideDetails?.userRideDetails?.data?.body?.[0],
  );
  const topCompanies = useSelector((state) => state?.userTopCompanies?.topCompanies?.data);
  const companyLoader = useSelector((state) => state?.userTopCompanies?.loading);
  const companyData = useSelector((state) => state?.userCompanyData?.companyData?.data);
  const companyDataLoader = useSelector((state) => state?.userCompanyData?.loading);
  const companyUpdateSuccess = useSelector(
    (state) => state?.updateCompany?.onBoardedCompay?.success,
  );

  const thirtyDaysAgo = new Date();
  thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
  const [dateFrom, setDateFrom] = useState(
    startDate && startDate !== 'null'
      ? startDate
      : startDate === 'null'
        ? ''
        : getDateFormat(thirtyDaysAgo, 'reservationDateFormat'),
  );
  const [dateTo, setDateTo] = useState(
    endDate && endDate !== 'null'
      ? endDate
      : endDate === 'null'
        ? ''
        : getDateFormat(new Date(), 'reservationDateFormat'),
  );

  const [locValue, setLocValue] = useState(locationData);

  let filterData = {
    dateFrom: dateFrom,
    dateTo: dateTo,
    location: userProfileData?.Company?.ServiceCity?.id || '',
  };

  let companyPayload = {
    page: page,
    pageSize: rowsPerPage,
    dateFrom: dateFrom,
    dateTo: dateTo,
    location: userProfileData?.Company?.ServiceCity?.id || '',
  };

  // Fetch compliance tracker data
  const fetchComplianceTrackerData = async (pageNumber = 0, pageSize = 10) => {
    setIsLoadingComplianceTracker(true);
    try {
      const response = await getVendorComplianceExpiryTracker({
        page: pageNumber,
        pageSize,
        location: userProfileData?.Company?.ServiceCity?.id || '',
        dateFrom: dateFrom,
        dateTo: dateTo,
      });
      setComplianceTrackerData(response?.data || { header: [], body: [], totalCount: 0 });
    } catch (err) {
      setComplianceTrackerData({ header: [], body: [], totalCount: 0 });
    } finally {
      setIsLoadingComplianceTracker(false);
    }
  };

  useEffect(() => {
    dispatch(getServiceCity());
  }, []);

  useEffect(() => {
    if (userProfileData?.Company?.ServiceCity?.id) {
      setLocValue({
        id: userProfileData?.Company?.ServiceCity?.id,
        name: userProfileData?.Company?.ServiceCity?.name,
      });
    }
  }, [userProfileData?.Company?.ServiceCity?.id]);

  useEffect(() => {
    if (userProfileData?.subRole) {
      dispatch(getRideDetails(filterData));
      dispatch(getTotalRegistration(filterData));
      dispatch(getRideAnalytic(filterData));
      dispatch(getOurCar(filterData));
      dispatch(getTopCompanies(filterData));
      dispatch(getCompanyData(companyPayload));
      dispatch(onLoaderTrigger(false));
    }
  }, [userProfileData?.subRole]);

  // Trigger API when tab changes
  useEffect(() => {
    if (tabValue === '2') {
      fetchComplianceTrackerData(compliancePage, complianceRowsPerPage);
    }
  }, [tabValue, compliancePage, complianceRowsPerPage, dateFrom, dateTo]);

  // Refetch when userProfileData loads
  useEffect(() => {
    if (tabValue === '2' && userProfileData?.Company?.ServiceCity?.id) {
      fetchComplianceTrackerData(compliancePage, complianceRowsPerPage);
    }
  }, [userProfileData?.Company?.ServiceCity?.id]);

  const tableData = useSelector((state) => state);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const onSelectDateRange = (newValue) => {
    if (newValue === null || newValue === 0) {
      setSearchParams({ startDate: 'null', endDate: 'null' });
      setDateFrom('');
      setDateTo('');
      filterData = { ...filterData, dateFrom: '', dateTo: '' };
    } else {
      setSearchParams({
        startDate: getDateFormat(newValue[0], 'reservationDateFormat'),
        endDate: getDateFormat(newValue[1], 'reservationDateFormat'),
      });
      setDateFrom(getDateFormat(newValue[0], 'reservationDateFormat'));
      setDateTo(getDateFormat(newValue[1], 'reservationDateFormat'));
      filterData = {
        ...filterData,
        dateFrom: getDateFormat(newValue[0], 'reservationDateFormat'),
        dateTo: getDateFormat(newValue[1], 'reservationDateFormat'),
      };
    }
    dispatch(getRideDetails(filterData));
    dispatch(getTotalRegistration(filterData));
    dispatch(getRideAnalytic(filterData));
    dispatch(getTopCompanies(filterData));

    // Refresh compliance data if on that tab
    if (tabValue === '2') {
      fetchComplianceTrackerData(compliancePage, complianceRowsPerPage);
    }
  };

  const onInputChange = (e, data) => {
    setLocValue(data);
    filterData = { ...filterData, location: data?.id };
    dispatch(getRideDetails(filterData));
    dispatch(getTotalRegistration(filterData));
    dispatch(getRideAnalytic(filterData));
    dispatch(getTopCompanies(filterData));
    dispatch(getCompanyData({ ...companyPayload, location: data?.id }));

    // Refresh compliance data if on that tab
    if (tabValue === '2') {
      fetchComplianceTrackerData(compliancePage, complianceRowsPerPage);
    }
  };

  const onClickMoreIcon = (value, type) => {
    if (type === 'Renew') {
      toggle();
      setCompanyDetails(value);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(getCompanyData({ ...companyPayload, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(
      getCompanyData({
        ...companyPayload,
        page: 0,
        pageSize: parseInt(event.target.value),
      }),
    );
  };

  // Compliance table pagination handlers
  const handleComplianceChangePage = (event, newPage) => {
    setCompliancePage(newPage);
    fetchComplianceTrackerData(newPage, complianceRowsPerPage);
  };

  const handleComplianceChangeRowsPerPage = (event) => {
    setComplianceRowsPerPage(parseInt(event.target.value));
    setCompliancePage(0);
    fetchComplianceTrackerData(0, parseInt(event.target.value));
  };

  // Handle compliance row click to navigate
  const onClickId = (row) => {
    navigate(`/compliance/documents`, {
      state: {
        id: row?.ComplianceValueMaster?.id,
        status: row?.ComplianceValueMaster?.status,
        name: row?.companyName,
        type: 'SubVendor',
        submitterId: row?.ComplianceValueMaster?.submitterId,
        fromSubVendorExpiry: true,
      },
    });
  };

  const onDialog = (data, image) => {
    setIsUpdateFromDashboard(true);
    let formData = new FormData();
    formData.append('agreement', image);
    formData.append('id', companyDetails?.companyId);
    formData.append(
      'contract[date]',
      getDateFormat(data?.chooseDate['$d'], 'onboardingDateFormat'),
    );
    formData.append('contract[startDate]', getDateFormat(data?.tenure[0], 'tenureDateFormat'));
    formData.append('contract[endDate]', getDateFormat(data?.tenure[1], 'tenureDateFormat'));
    dispatch(
      updateCompany(formData, {
        pageType: 'dashboardCompanyPage',
        setPrevieModel: setPrevieModel,
      }),
    );
    toggle();
  };

  //roles and permissions
  const roleAndPermissions = useSelector(
    (state) => state?.getRolesAndPermissions?.rolesAndPermissions,
  );
  const dashBoardRoleEnum = roleAndPermissionEnum.dashboard;
  const accessForall = handlePermissions(roleAndPermissions, dashBoardRoleEnum.moduleKey, {
    defaultAllAccess: dashBoardRoleEnum.all,
    customAccess: dashBoardRoleEnum.add,
  });
  const accessForRenewContract = handlePermissions(
    roleAndPermissions,
    dashBoardRoleEnum.moduleKey,
    { customAccess: dashBoardRoleEnum.renewContract },
  );

  const hasRenew = accessForall || accessForRenewContract;

  return (
    <Box>
      <Box className="dashboardSubHeader mb30">
        <CommonSubHeader
          selectCity={true}
          onSelectDateRange={onSelectDateRange}
          onInputChange={onInputChange}
          locValue={locValue}
          userProfileData={userProfileData}
          Location={locationData}
          dashboardSubHeader={true}
          dateFrom={dateFrom}
          dateTo={dateTo}
        />
      </Box>

      <DashboardCard
        cardData={dashboardCardData(dashBorardUpperData)}
        dateFrom={dateFrom}
        dateTo={dateTo}
        locValue={locValue}
      />

      <Box className="mb25">
        <ChartComponent tableData={tableData} />
      </Box>
      <Box className="mb25">
        <TopCompanies data={topCompanies} loader={companyLoader} />
      </Box>

      {/* Tab Container */}
      <Box className="borderShadowGrey mb25 p25">
        <TabContext value={tabValue}>
          <Box
            sx={{ borderBottom: 1, borderColor: 'divider' }}
            className="dashboard-tabs-alternative"
          >
            <TabList onChange={handleTabChange} aria-label="dashboard tabs">
              <Tab label="Contract Renewal" value="1" className="letterDisplay" />
              <Tab label="Subvendor Compliance Expiry" value="2" className="letterDisplay" />
            </TabList>
          </Box>

          {/* Contract Renewal Tab */}
          <Box
            role="tabpanel"
            hidden={tabValue !== '1'}
            id="tabpanel-1"
            aria-labelledby="tab-1"
            className="pt20"
          >
            {tabValue === '1' && (
              <>
                {/* <Typography variant="head5" className="fw600 mb20">
                  Contract Renewal
                </Typography> */}
                {companyDataLoader ? (
                  <Loader height={'50vh'} />
                ) : (
                  <CommonTable
                    data={companyData}
                    colorBlue="blue"
                    tabName={'companyData'}
                    onClickMoreIcon={onClickMoreIcon}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    viewMoreIcon={!hasRenew}
                  />
                )}
              </>
            )}
          </Box>

          {/* Vendor Compliance Expiry Tab */}
          <Box
            role="tabpanel"
            hidden={tabValue !== '2'}
            id="tabpanel-2"
            aria-labelledby="tab-2"
            className="pt20"
          >
            {tabValue === '2' && (
              <>
                {/* <Typography variant="head5" className="fw600 mb20">
                  SubVendor Compliance Expiry
                </Typography> */}
                {isLoadingComplianceTracker ? (
                  <Loader height={'50vh'} />
                ) : (
                  <CommonTable
                    data={complianceTrackerData}
                    colorBlue="blue"
                    tabName={'vendorComplianceExpiry'}
                    isClickable={true}
                    onClickId={onClickId}
                    handleChangePage={handleComplianceChangePage}
                    handleChangeRowsPerPage={handleComplianceChangeRowsPerPage}
                    page={compliancePage}
                    rowsPerPage={complianceRowsPerPage}
                    showPagination={false}
                    from="subVendorExpiry"
                  />
                )}
              </>
            )}
          </Box>
        </TabContext>
      </Box>

      <CommonDialog
        className="mb20"
        open={open}
        handleClose={toggle}
        button={'dialogButton'}
        companyDetails={companyDetails}
        onSubmittBtn={onDialog}
        selectType={'updateDoc'}
        type={'dashboardCompany'}
        formData={updateCompanyDoc}
        btnClass={'btnMedium'}
      />

      <CommonPreviewDialog
        open={previewModel}
        companyDetails={companyDetails}
        handleClose={setPrevieModel}
        companyPayload={companyPayload}
      />
    </Box>
  );
};

export default Dashboard;
